import React, { useEffect, useState, ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";

export interface HeaderMenuItem {
  label: string | ReactNode;
  icon?: ReactNode;
  action: (closeNav: () => void) => void;
  isActive?: boolean;
  mobileOnly?: boolean;
  badge?: ReactNode;
  className?: string;
}

interface HeaderProps {
  menuItems: HeaderMenuItem[];
  mobileProfileCard?: ReactNode;
  rightActions?: ReactNode;
}

const Header: React.FC<HeaderProps> = ({
  menuItems,
  mobileProfileCard,
  rightActions,
}) => {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isFixed, setIsFixed] = useState(false);
  const [isNavOpen, setIsNavOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;

      setIsScrolled(scrollY > 0);
      setIsFixed(scrollY > 150);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (!isNavOpen) return;

    const scrollY = window.scrollY;

    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = "100%";
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.overflow = "";

      window.scrollTo(0, scrollY);
    };
  }, [isNavOpen]);

  const closeNav = () => setIsNavOpen(false);

  return (
    <>
      {isFixed && <div className="header-spacer" />}

      <header
        className={`
    custom-header
    ${isScrolled ? "scrolled" : ""}
    ${isFixed ? "fixed" : ""}
  `}
      >
        <div className="container custom-nav">
          <div className="custom-nav-left">
            <button
              className="brand"
              type="button"
              onClick={() => {
                closeNav();
                navigate("/");
              }}
            >
              <img
                src="/mimocupido-logo.png"
                alt="Mimo Cupido"
                className="logo-icon"
              />
              <span className="brand-text">MIMO CUPIDO</span>
            </button>
          </div>

          <div
            className={`custom-menu-backdrop ${isNavOpen ? "open" : ""}`}
            onClick={closeNav}
          />

          <nav className={`custom-menu ${isNavOpen ? "open" : ""}`}>
            <div className="mobile-menu-header">
              <span className="menu-title"></span>
              <button
                type="button"
                className="close-menu"
                onClick={closeNav}
                aria-label="Fechar menu"
              >
                ×
              </button>
            </div>

            {mobileProfileCard && (
              <div className="mobile-only-card-wrapper">
                {mobileProfileCard}
              </div>
            )}

            <div className="menu-items-wrapper">
              {menuItems.map((item, index) => (
                <button
                  key={index}
                  type="button"
                  className={`menu-link-btn ${item.isActive ? "active" : ""} ${item.mobileOnly ? "item-mobile-only" : ""} ${item.className || ""}`.trim()}
                  onClick={() => item.action(closeNav)}
                >
                  {item.icon && <span className="icon">{item.icon}</span>}
                  <span className="item-label-text">{item.label}</span>
                  {item.badge}
                </button>
              ))}
            </div>
          </nav>

          <div className="custom-nav-right">
            {rightActions}

            <button
              className={`custom-menu-toggle ${isNavOpen ? "open" : ""}`}
              type="button"
              onClick={() => setIsNavOpen(!isNavOpen)}
              aria-label="Menu"
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
